import { Art57Node } from "./Art57Node";

export class Art57NodeList extends Art57Node {
    getHeaders(): string[] {
      return [];
    }

  }